import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { ClientService } from '/src/api';
import { BreadcrumbNav, ListPage, PageHeader, StatementList } from '/src/components';
import { config } from '/src/config';
import { useGlobalStore, useUserStore } from '/src/context';
import { useProductTour } from '/src/hooks/useProductTour';
import { toastMessages } from '/src/lib/toast';
import { getPageTitle } from '/src/utils';
import { statementsTour } from '/src/utils/productTours';

export const ListStatementsPage = observer(() => {
  /** Context **/
  const userStore = useUserStore();
  const globalStore = useGlobalStore();
  const params = useParams();

  /** State **/
  const [clientName, setClientName] = useState('');

  /** Computed **/
  const clientId = parseInt(params.client_id ?? '');
  const isLoading = !clientName;

  /** Effects **/
  useEffect(() => {
    if (clientName) {
      document.title = getPageTitle(config.client.basePageTitle, clientName, 'Statements');
    } else if (!clientName && userStore.user) {
      if (userStore.isFacilityUser) {
        setClientName(userStore.user.clients.find((client) => client.id === clientId)?.name ?? '');
      } else {
        ClientService.get({ id: clientId })
          .then((client) => setClientName(client.name))
          .catch((err) => globalStore.handleApiError(err, toastMessages.listIncentiveStatements.error));
      }
    }
  }, [clientName]);

  /* Product Tour */
  useProductTour({
    tourName: 'statements-tour',
    steps: statementsTour,
    autoStart: true,
    showOnce: true,
  });

  /** Render **/
  return (
    <ListPage
      title={clientName}
      pageHeader={<PageHeader title={clientName} />}
      breadcrumbNav={
        <BreadcrumbNav
          previousPages={[
            { name: 'Clients', link: !userStore.isClientUser && !userStore.isFacilityUser ? '/clients' : undefined },
            { name: clientName, link: !userStore.isFacilityUser ? `/clients/${clientId}` : undefined },
          ]}
          currentPageName="Statements"
        />
      }
      isLoading={isLoading}
    >
      <StatementList clientId={clientId} data-tour="statements-list" />
    </ListPage>
  );
});
